<template>
    <div>
        <template v-if=" actionPlanStatistics.constructor == Object">
            <div class='content contentPlanStatistics' v-for="(value,key,index) in actionPlanStatistics">
                    <template v-if="index==0">
                        <BigTitle title='part.3 行动计划'></BigTitle>
                        <MiddleTitle title='规划统计'></MiddleTitle>
                    </template>
                    <SmallTitle :title="key"></SmallTitle>
                    <div style="padding-top: 10px">
                    <table>
                        <tbody>
                        <tr>
                            <th>学期</th>
                            <th>月考</th>
                            <th>行动计划次数</th>
                            <th>行动计划制定时间</th>
                            <th><p>总任务<br/>数量</p></th>
                            <th><p>任务完成<br/>得分</p></th>
                            <th><p>完成效果<br/>得分</p></th>
                            <th>学科</th>
                            <th>任务数量</th>
                            <th><p>任务完成<br/>得分</p></th>
                            <th><p>完成效果<br/>得分</p></th>
                        </tr>
                        <template v-for="(it,i) in value.month" >
                            <tr  v-if="it.constructor == Object" >
                            <td  style="background-color: #E5F2F9;">{{key}}</td>
                            <td>第{{i+1}}次月考</td>
                            <td class='border0'>
                                <table class='table' width="100%" height="100%">
                                    <tbody>
                                        <template v-if="it.actionPlan ">
                                            <tr v-for="(item2,key2) in it.actionPlan" :key="key2">
                                                <td>
                                                    {{item2.name}}行动计划
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </td>
                            <td class='border0'>
                                <table class='table'>
                                    <tbody>
                                        <template v-if="it.actionPlan ">
                                            <tr v-for="(item2,key2) in it.actionPlan" :key="key2">
                                                <td>
                                                    {{item2.planTime}}
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>

                            </td>
                            <td>
                                {{it.total && it.total.taskNumber}}
                            </td>
                            <td>
                                {{it.total && it.total.taskComplete}}
                            </td>
                            <td>
                                {{it.total && it.total.completeEffect}}
                            </td>
                            <td>
                                <table class="table table2">
                                    <tbody>
                                        <template v-if="it.subject ">
                                            <tr v-for="(item2,key2) in it.subject" :key="key2">
                                                <td>
                                                    {{item2.subject}}
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </td>
                            <td>
                                <table class="table table2">
                                    <tbody>
                                        <template v-if="it.subject ">
                                            <tr v-for="(item2,key2) in it.subject" :key="key2">
                                                <td>
                                                    {{item2.taskNumber}}
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </td>
                            <td>
                                <table class="table table2">
                                    <tbody>
                                        <template v-if="it.subject ">
                                            <tr v-for="(item2,key2) in it.subject" :key="key2">
                                                <td>
                                                    {{item2.taskComplete}}
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </td>
                            <td>
                                <table class="table table2">
                                    <tbody>
                                        <template v-if="it.subject ">
                                            <tr v-for="(item2,key2) in it.subject" :key="key2">
                                                <td>
                                                    {{item2.completeEffect}}
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </template>
        <template v-else>
            <div class='content contentPlanStatistics'>
                <BigTitle title='part.3 行动计划'></BigTitle>
                <MiddleTitle title='规划统计'></MiddleTitle>
                <div class="noContent">
                    暂无内容！~~~
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import BigTitle from './bigTitle'
import MiddleTitle from './middleTitle'
import SmallTitle from './smallTitle'
import PlanTable from "./planTable/planTable";
import CircleName from "@/components/consultant/CircleName.vue";
export default {
    name: "pagePlanStatistics",
    props: ['actionPlanStatistics'],
    components: {
        BigTitle,MiddleTitle,SmallTitle,PlanTable,CircleName
    },
    data() {
        return {
        }
    },
    computed: {
    },
    methods: {

    },
}
</script>
<style scoped lang="less">
.pagePlanStatistics {

}
</style>